import { useLocation, useNavigate } from "react-router-dom";

import "./customized-template-preview.scss";
import { useAppSelector } from "@/store/hooks";
import { message } from "antd";
import { recordTemplateUsage } from "@/api/weave-x";

function CustomizedTemplatePreview() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isLoading } = useAppSelector((state) => state.canvas);

  const { state } = location;

  if (!state) {
    return <div className="error-message">Error: No content provided</div>;
  }

  const handleCancel = () => {
    navigate(-1);
  };

  const handleContinue = async () => {
    if (isLoading) {
      message.info(
        "You have an pending canvas operation, please wait for it to complete",
      );
      return;
    }

    navigate("/home/planning/guided-mode-v2", {
      state: {
        ...state,
        useTemplate: true,
      },
    });
    // Record template usage if it's a community template
    if (state?.template?.templateId) {
      try {
        await recordTemplateUsage(state.template.templateId);
      } catch (error) {
        console.error("Error recording template usage:", error);
        // Continue with navigation even if recording fails
      }
    }
  };

  return (
    <div className="customized-template-preview-container">
      <iframe
        srcDoc={state?.template?.templateSourceCode}
        title="preview"
        className="customized-template-preview-iframe"
      />
      <div className="customized-template-preview-footer">
        <button
          className="customized-template-preview-footer-button"
          onClick={handleCancel}
        >
          Cancel
        </button>
        <button
          className="customized-template-preview-footer-button"
          onClick={handleContinue}
        >
          Continue
        </button>
      </div>
    </div>
  );
}

export default CustomizedTemplatePreview;
